import { useContext, useEffect, useRef, useState } from "react";
import { TemplateContext2Provider } from "../../contexts/TemplateContext2";
import { Button, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import parse from "html-react-parser";
import TemplateTwoLogic from "./template-logic";
import QuestionReUsable from "../../components/re-usable/questions-resuable";
import ButtonReuseable from "../../components/re-usable/button-resuable";
import { ImageOrColorDecider, OpaqueDeciderForDescription, OpaqueDeciderForQuestionForm, resizeImageOrColorDecider } from "../../../helpers/container-style-decider";
import { checkIfAnyStateHasValue, getDescription } from "../../../helpers/description-empty";
import "./template-two.scss";

export default function TemplateTwo() {
    // trigger build
    const {
        rowOneImageLink,

        rowTwoValue,
        rowTwoDescription,
        rowTwoImageLink,
        rowTwoBackgroundColor,
        rowTwoOpaqueValue,

        rowThreeImageLink,
        rowThreeDescription,
        rowThreeBackgroundColor,
        rowThreeOpaqueValue,

        rowFourImageLink,
        rowFourDescription,
        rowFourOpaqueValue,
        rowFourBackgroundColor,
        rowFourValue,

        rowFiveImageLink,
        rowFiveDescription,
        rowFiveOpaqueValue,
        rowFiveBackgroundColor,

        rowSixImageLink,
        rowSixDescription,
        rowSixOpaqueValue,
        rowSixBackgroundColor,

        rowSevenImageLink,
        rowSevenDescription,
        rowSevenOpaqueValue,
        rowSevenBackgroundColor,

        rowEightImageLink,
        rowEightDescription,
        rowEightOpaqueValue,
        rowEightBackgroundColor,

        rowTenImageLink,
        middleContainerImageLink,
        middleContainerBackgroundColor,
        value,

        rowResizeDescription,
        rowResizeOpaqueValue,
        rowResizeImageLink,
        rowResizeBackgroundColor,
        widthPercentage,

        listChecked,
        questionBackgroundColor,
        questionsFontColor,
        questions,
        templateData,
        questionFormOpaqueValue,
        containerValue,
        containerBackgroundColor,
        containerBackgroundImage,
        setQuestions,
        rowOneButtonColor,
        rowOneButtonText,
        rowOneFontColor,
        rowThreeButtonColor,
        rowThreeFontColor,
        rowThreeButtonText,
        rowFiveButtonColor,
        rowFiveFontColor,
        rowFiveButtonText,

        questionFormValue,
        questionBackgroundImage,

        rowOneHeight,
        rowOneWidthPercentage,
        rowTwoHeight,
        rowTwoWidthPercentage,
        rowThreeHeight,
        rowThreeWidthPercentage,
        rowFourHeight,
        rowFourWidthPercentage,
        rowFiveHeight,
        rowFiveWidthPercentage,
        rowTenHeight,
        rowTenWidthPercentage,

        rowOneHideApply,
        rowThreeHideApply,
        rowFiveHideApply,

        customForm,
        customFormContent,
        customFormContentFooter,

        rowNineFooterText,
    } = useContext(TemplateContext2Provider);

    const [loaded, setLoaded] = useState(true);
    const loadClick = useRef(false);

    const scrollToNine = () => {
        const nineDiv = document.getElementById(
            `preview-row-nine-template-2-scroll`
        );
        if (nineDiv) {
            nineDiv.scrollIntoView({ behavior: "smooth" });
        }
    };

    const buttonStyle = (background, color) => {
        return {
            background: background,
            color: color,
        }
    };

    const resizeCss = (height, widthPercentage, widthLimit, heightLimit) => {
        return {
            height: `auto`,
            width: widthPercentage > 0 && `${Math.min(widthPercentage, 100)}%`,
            marginLeft: "auto",
            marginRight: "auto",
        }
    };

    const middleContainerVariables = [
        rowSixImageLink,
        getDescription(rowSixDescription),
        rowSevenImageLink,
        getDescription(rowSevenDescription),
        rowEightImageLink,
        getDescription(rowEightDescription),
        middleContainerImageLink,
        // middleContainerBackgroundColor
    ];

    const setupLink = (theLink) => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = theLink
        link.id = "dynamic-style";
        link.onload = () => setLoaded(true);
        document.head.appendChild(link);
    }

    const clickHandler = (event) => {
        const searchClasses = ['search2', 'search3', 'search4'];
        const isSearchElement = searchClasses.some(cls => event.target.classList.contains(cls)) ||
                    searchClasses.some(cls => event.target.closest(`.${cls}`)) ||
                    event.target.id === 'sEARCH' ||
                    event.target.closest('#sEARCH');

        if (isSearchElement) {
            const targetElement = document.getElementById('preview-row-nine-template-2-scroll');
            const targetElement1 = document.getElementById('applyForm');
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            } else if (targetElement1) {
                targetElement1.scrollIntoView({ behavior: 'smooth' });
            }
        }
        if (event.target.classList.contains('component-37') || 
        event.target.closest(`.component-37`)
        ) {
            document.querySelector('.nav-mobile').classList.toggle('show-menu');
            if (document.querySelector('.hero-banner-wrapper')) {
                const heroBanner = document.querySelector('.hero-banner-wrapper');
                if (heroBanner.style.zIndex === '9999') {
                    heroBanner.style.zIndex = '';
                } else {
                    heroBanner.style.zIndex = '9999';
                }
            }
        }
    }

    // Hard code javascript for specific url
    useEffect(() => {
        // Update placeholder from label and delete label
        
        setLoaded(true)
        // Check if the scripts already exist before adding them
        setInterval(() => {
            if (!document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js"]')) {
                const script1 = document.createElement("script");
                script1.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js";
                script1.async = true;
                script1.onload = () => {
                    // jQuery is now available
                    console.log('jQuery loaded:', !!window.jQuery);
                    // Example usage of jQuery
                    window.$(document).ready(function () {
                        if (!document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js"]')) {
                            const script = document.createElement("script");
                            script.src = "https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js";
                            script.async = true;
                            document.body.appendChild(script);
                        }
                    });
                };
                document.body.appendChild(script1);
            }
        }, 1000);


        if(customFormContent) {
            const regex = /href="(https?:\/\/[^"]+)"/g;
            const urls = [...customFormContent.matchAll(regex)].map(match => match[1]);

            const loadStyles = () => {
                for (const url of urls) {
                    if(urls.includes('.css')) {
                        setupLink(url)
                    }
                }
            };
        
            loadStyles();
        }
        setTimeout(() => {
            document.querySelectorAll("#applyForm .ant-form-item .ant-form-item-label label").forEach((label) => {
                const inputId = label.getAttribute("for");
                if (inputId) {
                    const input = document.getElementById(inputId);
                    const hasRequired = label.className.includes('ant-form-item-required');
                    if (input) {
                        if (input.type === 'text') {
                            input.placeholder = label.textContent.trim() + (hasRequired ? ' *' : '');
                            label.remove(); // Delete label after update placeholder
                        } else if (input.type === 'search') {
                            const selectWrapper = input.closest('.ant-select');
                            if (selectWrapper) {
                                const placeholderSpan = selectWrapper.querySelector('.ant-select-selection-placeholder');
                                if (placeholderSpan) {
                                    placeholderSpan.textContent = label.textContent.trim() + (hasRequired ? ' *' : '');
                                    label.remove();
                                }
                            }
                        } else if (input.tagName === 'DIV' && hasRequired) {
                            label.classList.remove('ant-form-item-required')
                            label.textContent = label.textContent.trim() + (hasRequired ? ' *' : '');
                        }
                    }
                }
            });
        
            // Move elements privacy to bottom `.preview-row-nine-container` after `.footer-section .form-section` 
            // Move elements privacy mobile to bottom  `.footer-section .footer-wrapper` after `.preview-row-nine-container` for the mobile version
            
            if (window.innerWidth <= 768) {
                const target1 = document.querySelector(".preview-row-nine-container");
                const reference1 = document.querySelector(".footer-container");
                const reference2 = document.querySelector(".footer23");
                const reference3 = document.querySelector(".koch-nationalease .footer22");
                if (target1 && reference1) {
                    reference1.parentNode.insertBefore(target1, reference1);
                }
                if (target1 && reference3) {
                    reference3.parentNode.insertBefore(target1, reference3);
                } else {
                    if (target1 && reference2) {
                        reference2.parentNode.insertBefore(target1, reference2);
                    }
                }
            } else {
                const target = document.querySelector(".preview-row-nine-container");
                const reference = document.querySelector(".footer-section > .footer-section-inner");
            
                if (target && reference) {
                    reference.parentNode.insertBefore(target, reference.nextSibling);
                }

                const arrElem = [
                    '.preview-row-nine-container', '.footer-section > .footer-wrapper', '.footer-section > .footer-info',
                    
                ]
                for (const element of arrElem) {
                    const target = document.querySelector(element);  // Element to move
                    const destination = document.querySelector(".footer-section");  // New parent

                    if (target && destination) {
                        destination.appendChild(target); // Moves the element inside the new parent
                    }
                }
                // owner-operator

                const arrOOElem = [
                    '.preview-row-nine-container', '.ptl-owner-operator-page .footer-section1 > .footer-content1', '.footer-section1 > .footer-container',
                ]
                for (const element of arrOOElem) {
                    const target = document.querySelector(element);  // Element to move
                    const destination = document.querySelector(".footer-section1");  // New parent

                    if (target && destination) {
                        destination.appendChild(target); // Moves the element inside the new parent
                    }
                }
                const target_koch = document.querySelector('.preview-row-nine-container');
                const destination_koch = document.querySelector(".koch-nationalease .footer23");  // New parent

                if (destination_koch && target_koch) {
                    destination_koch.parentNode.insertBefore(target_koch, destination_koch);
                    const whyChooseUs = document.querySelector('.why-choose-us');
                    if (whyChooseUs) {
                    whyChooseUs.style.height = 'auto';
                    }
                }

            }
            
        }, 1000);

        setTimeout(() => {
            setLoaded(false)
        }, 3000);

        if (!loadClick.current) {
            loadClick.current = true;
            document.addEventListener('click', (event) => clickHandler(event));
        }
        if (!!document.querySelector('.koch-nationalease')) {
            document.querySelectorAll('[class^="btn"], [class^="button"]').forEach(function (button) {
                const contactUsText = Array.from(button.querySelectorAll('*')).some(el => el.textContent.trim().toLowerCase() === 'contact us');
                if (contactUsText) {
                    button.addEventListener('click', function () {
                        document.getElementById('applyForm').scrollIntoView({ behavior: 'smooth' });
                    });
                }
            });
        }
        
        const exampleUrl = [
            "cdn.gtbuilder.io",
             "cdn.gtbuilder.io/ptl-regional-and-dedicated",
             "drive4ptl.com",
             "drive4ptl.com/ptl-regional-and-dedicated",
             "hire.drive4ptl.com",
             "hire.drive4ptl.com/regional-and-dedicated",
        ];
        if (exampleUrl.includes(templateData?.templateUrl)) {
            const initializeCarousel = () => {
                if (
                    window.$ && window.$.fn.owlCarousel && !window.$(".owl-carousel")?.hasClass('owl-loaded') &&
                    !!document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js"]') &&
                    !!document.querySelector('script[src="https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js"]')
                ) {
                    window.$(".owl-carousel").owlCarousel({
                        items: 4,
                        margin: 30,
                        dots: false,
                        nav: true,
                        loop: true,
                        responsive: {
                            0: {
                                items: 1,
                            },
                            768: {
                                items: 4,
                            },
                        }
                    });
                } else {
                    setTimeout(initializeCarousel, 2000);
                }
            };

            initializeCarousel();
        }

        return () => {
            document.removeEventListener('click', (event) => clickHandler(event));
        };
    }, [customFormContent, templateData?.templateUrl]);


    return (
        <>
            { loaded &&
                        (<div className="sprint-load"><Spin indicator={<LoadingOutlined spin />} fullscreen /></div>) }
            <TemplateTwoLogic />
            <div
                className="template-two-preview-container"
                style={ImageOrColorDecider(
                    containerValue,
                    containerBackgroundImage,
                    containerBackgroundColor
                )}
            >
                {!customForm ? (
                    <>
                        {rowOneImageLink && (
                            <div className="preview-row-one-container">
                                {!rowOneHideApply && (
                                    <div className="apply-button">
                                        <Button style={buttonStyle(rowOneButtonColor, rowOneFontColor)} onClick={() => scrollToNine()}>{rowOneButtonText}</Button>
                                    </div>
                                )}
                                <>
                                    <img
                                        src={rowOneImageLink}
                                        alt="Uploaded"
                                        style={resizeCss(rowOneHeight, rowOneWidthPercentage, 156, 156)}
                                    />
                                </>
                            </div>
                        )}
                        {(rowTwoImageLink || rowTwoDescription) && (
                            <div
                                className={rowTwoValue == 0 ? "preview-row-two-container" : "preview-row-two-container-without-min-height"}
                                style={resizeImageOrColorDecider(
                                    rowTwoValue, rowTwoBackgroundColor,
                                )}
                            >
                                {rowTwoDescription && (
                                    <div className="description-container">
                                        <div
                                            className="description"
                                            style={rowTwoValue == 1 ? OpaqueDeciderForDescription(
                                                rowTwoOpaqueValue,
                                                rowTwoBackgroundColor
                                            ) : { background: 'none' }}
                                        >
                                            {parse(`${rowTwoDescription}`)}
                                        </div>
                                    </div>
                                )}
                                {rowTwoValue == 0 && rowTwoImageLink && (
                                    <div className="preview-row-ten-container">
                                        <img alt="preview-row-ten" src={rowTwoImageLink} style={resizeCss(rowTwoHeight, rowTwoWidthPercentage, 300, 300)}></img>
                                    </div>
                                )}
                            </div>
                        )}
                        {(rowThreeImageLink || rowThreeDescription) && (
                            <div className={rowThreeImageLink ? "preview-row-three-container" : "preview-row-three-container-without-min-height"}>
                                {rowThreeDescription && (
                                    <div className="description-container">
                                        <div
                                            className="description"
                                            style={OpaqueDeciderForDescription(
                                                rowThreeOpaqueValue,
                                                rowThreeBackgroundColor
                                            )}
                                        >
                                            {parse(`${rowThreeDescription}`)}
                                        </div>
                                        {!rowThreeHideApply && (
                                            <div className="apply-button">
                                                <Button style={buttonStyle(rowThreeButtonColor, rowThreeFontColor)} onClick={() => scrollToNine()}>
                                                    {rowThreeButtonText}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {rowThreeImageLink && (
                                    <div className="preview-row-ten-container">
                                        <img alt="preview-row-ten"
                                            src={rowThreeImageLink}
                                            style={resizeCss(rowThreeHeight, rowThreeWidthPercentage, 600, 450)}
                                        ></img>
                                    </div>
                                )}
                            </div>
                        )}
                        {(rowFourImageLink || rowFourDescription) && (
                            <div
                                className={rowFourValue == 0 ? "preview-row-four-container" : "preview-row-four-container-without-min-height"}
                                style={resizeImageOrColorDecider(
                                    rowFourValue, rowFourBackgroundColor,
                                )}
                            >
                                {rowFourDescription && (
                                    <div className="description-container">
                                        <div
                                            className="description"
                                            style={rowFourValue == 1 ? OpaqueDeciderForDescription(
                                                rowFourOpaqueValue,
                                                rowFourBackgroundColor
                                            ) : { background: 'none' }}
                                        >
                                            {parse(`${rowFourDescription}`)}
                                        </div>
                                    </div>
                                )}
                                {rowFourValue == 0 && rowFourImageLink && (
                                    <div className="preview-row-ten-container">
                                        <img alt="preview-row-ten" src={rowFourImageLink} style={resizeCss(rowFourHeight, rowFourWidthPercentage, 300, 300)}></img>
                                    </div>
                                )}
                            </div>
                        )}
                        {(rowFiveImageLink || rowFiveDescription) && (
                            <div className={rowFiveImageLink ? "preview-row-five-container" : "preview-row-five-container-without-min-height"}
                            >
                                {rowFiveDescription && (
                                    <div className="description-container">
                                        <div
                                            className="description"
                                            style={OpaqueDeciderForDescription(
                                                rowFiveOpaqueValue,
                                                rowFiveBackgroundColor
                                            )}
                                        >
                                            {parse(`${rowFiveDescription}`)}
                                        </div>
                                        {!rowFiveHideApply && (
                                            <div className="apply-button">
                                                <Button style={buttonStyle(rowFiveButtonColor, rowFiveFontColor)} onClick={() => scrollToNine()}>{rowFiveButtonText}</Button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {rowFiveImageLink && (
                                    <div className="preview-row-ten-container">
                                        <img alt="preview-row-ten"
                                            src={rowFiveImageLink}
                                            style={resizeCss(rowFiveHeight, rowFiveWidthPercentage, 600, 450)}
                                        ></img>
                                    </div>
                                )}
                            </div>
                        )}
                        <div className={checkIfAnyStateHasValue([rowResizeImageLink, getDescription(rowResizeDescription)]) ? "preview-row-resize-container" : 'no-display'}>
                            <div
                                className="description-container"
                                style={{
                                    ...OpaqueDeciderForDescription(
                                        rowResizeOpaqueValue,
                                        rowResizeBackgroundColor
                                    ),
                                    width: `${widthPercentage}%`,
                                }}
                            >
                                <div className="description">
                                    {rowResizeDescription && parse(`${rowResizeDescription}`)}
                                </div>
                            </div>
                            {rowResizeImageLink && (
                                <div className="image">
                                    <img alt="preview-row-resize" src={rowResizeImageLink}></img>
                                </div>
                            )}
                        </div>
                        <div className={checkIfAnyStateHasValue(middleContainerVariables) ? "preview-middle-container-template-2" : 'no-display'}
                            style={ImageOrColorDecider(
                                value,
                                middleContainerImageLink,
                                middleContainerBackgroundColor,
                            )}
                        >
                            <div className="content">
                                <div className={checkIfAnyStateHasValue([rowSixImageLink, getDescription(rowSixDescription)]) ? "preview-row-six-container" : 'no-display'}>
                                    <div className="image-description-container">
                                        <div className="image">
                                            {rowSixImageLink && (
                                                <img alt="row-six" src={rowSixImageLink}></img>
                                            )}
                                        </div>
                                        <div
                                            className="description"
                                            style={OpaqueDeciderForDescription(
                                                rowSixOpaqueValue,
                                                rowSixBackgroundColor
                                            )}
                                        >
                                            {rowSixDescription && parse(`${rowSixDescription}`)}
                                        </div>
                                    </div>
                                </div>
                                <div className={checkIfAnyStateHasValue([rowSevenImageLink, getDescription(rowSevenDescription)]) ? "preview-row-seven-container" : 'no-display'}>
                                    <div className="image-description-container">
                                        <div
                                            className="description"
                                            style={OpaqueDeciderForDescription(
                                                rowSevenOpaqueValue,
                                                rowSevenBackgroundColor
                                            )}
                                        >
                                            {rowSevenDescription && parse(`${rowSevenDescription}`)}
                                        </div>
                                        <div className="image">
                                            {rowSevenImageLink && (
                                                <img alt="row-seven" src={rowSevenImageLink}></img>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={checkIfAnyStateHasValue([rowEightImageLink, getDescription(rowEightDescription)]) ? "preview-row-eight-container" : 'no-display'}>
                                    <div className="image-description-container">
                                        <div className="image">
                                            {rowEightImageLink && (
                                                <img alt="row-eight" src={rowEightImageLink}></img>
                                            )}
                                        </div>
                                        <div
                                            className="description"
                                            style={OpaqueDeciderForDescription(
                                                rowEightOpaqueValue,
                                                rowEightBackgroundColor
                                            )}
                                        >
                                            {rowEightDescription && parse(`${rowEightDescription}`)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                        <div className="custom-form">
                            {customFormContent && (
                                parse(customFormContent)
                            )}
                        </div>
                    
                )}
                {templateData?.isShowForm && (
                    <div
                    className="preview-row-nine-container"
                    style={questionFormOpaqueValue ? OpaqueDeciderForQuestionForm(
                        questionFormOpaqueValue,
                        questionBackgroundColor
                    ) : ImageOrColorDecider(questionFormValue, questionBackgroundImage, questionBackgroundColor)}
                    id="preview-row-nine-template-2-scroll"
                >
                    <QuestionReUsable templateData={templateData} questions={questions} questionsFontColor={questionsFontColor} listChecked={listChecked} setQuestions={setQuestions} temlateType={2} noSpace={true} heading={rowNineFooterText} questionBackgroundColor={questionBackgroundColor} />
                </div>
                )}
                {!templateData?.isShowForm && templateData?.isRedirect && (
                     <div
                        className="preview-row-nine-container"
                        style={questionFormOpaqueValue ? OpaqueDeciderForQuestionForm(
                            questionFormOpaqueValue,
                            questionBackgroundColor
                        ) : ImageOrColorDecider(questionFormValue, questionBackgroundImage, questionBackgroundColor)}
                        id="preview-row-nine-template-2-scroll"
                    >
                        <ButtonReuseable templateData={templateData} questions={questions} questionsFontColor={questionsFontColor} listChecked={listChecked} setQuestions={setQuestions} temlateType={2} noSpace={true} heading={rowNineFooterText} questionBackgroundColor={questionBackgroundColor} />
                    </div>
                )}
                {!customForm && (
                    <>
                        {rowTenImageLink && (
                            <div className="preview-row-ten-container">
                                <img alt="preview-row-ten" src={rowTenImageLink} style={resizeCss(rowTenHeight, rowTenWidthPercentage, 156, 156)}></img>
                            </div>
                        )}
                    </>
                )}
                {customFormContentFooter && (
                    <div className="custom-form-footer">
                        {parse(customFormContentFooter)}
                    </div>
                )}
            </div>
        </>
    )
}
